import { ChangeDetectionStrategy, Component, EventEmitter, input, Output, OnDestroy, inject, computed } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';

import { AvatarsComponent, TooltipModule } from '@libs/ui-lib';
import { Alert, DynamicRouterLinkDirective, PushTagOnClickDirective, TagEvent } from '@libs/shared-services';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PhoneFormatPipe } from '@libs/patients';
import { healthHistoryActions, selectSiteSettingsPmsType } from '@libs/store';
import { Store } from '@ngrx/store';
import { PmsType } from '@ffd/api-client';
import { AppointmentStatusChipComponent } from '../schedule-calendar';
import { TimeRangeFormatPipe } from '../time-range-format';
import { ScheduleAlertComponent } from './schedule-alert/schedule-alert.component';
import { ScheduleDetailsVM } from './schedule-details.vm';

@Component({
  selector: 'lib-schedule-details',
  imports: [
    SvgIconComponent,
    TranslateModule,
    DynamicRouterLinkDirective,
    TimeRangeFormatPipe,
    DatePipe,
    PushTagOnClickDirective,
    TooltipModule,
    CommonModule,
    PhoneFormatPipe,
    AvatarsComponent,
    AppointmentStatusChipComponent,
    ScheduleAlertComponent,
  ],
  templateUrl: './schedule-details.component.html',
  styleUrl: './schedule-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleDetailsComponent implements OnDestroy {
  private readonly store = inject(Store);

  public vm = input.required<ScheduleDetailsVM>();
  private readonly pmsType = this.store.selectSignal(selectSiteSettingsPmsType);
  public readonly isOpenDental = computed(() => this.pmsType() === PmsType.OPEN_DENTAL);

  @Output() public avatarClick = new EventEmitter<void>();
  @Output() public editClick = new EventEmitter<void>();

  protected isExpanded = true;
  protected expandedAlertIndex: number | null = null;

  protected TagEvent = TagEvent;

  public ngOnDestroy(): void {
    this.store.dispatch(healthHistoryActions.resetHealthHistoryAndPatientAlerts());
  }
  public alerts = computed((): Alert[] => {
    const vmValue = this.vm();
    const alerts: Alert[] = [...vmValue.patientAlertItems];
    if (vmValue.medicalAlertItem) {
      alerts.unshift(vmValue.medicalAlertItem);
    }

    return alerts;
  });

  public onAvatarClick(): void {
    if (this.vm().appointmentDetails.isPreRegistrationAppointment) {
      return;
    }

    this.avatarClick.emit();
  }

  public onEditClick(): void {
    this.editClick.emit();
  }

  public onClearExpandedIndex(): void {
    this.expandedAlertIndex = null;
  }

  public onToggleAlert(alertIndex: number): void {
    this.expandedAlertIndex = this.expandedAlertIndex === alertIndex ? null : alertIndex;
  }

  public isAlertExpanded(alertIndex: number): boolean {
    return this.expandedAlertIndex === alertIndex;
  }
}
